import React from 'react'
import '@/styles/main.css'
import { AppRouter } from './AppRouter'
import { AppProvider } from './AppContext'
import TopBar from '@/components/shell/TopBar'
import ScrollReveal from '@/components/shell/ScrollReveal'
import { ToastHost } from '@/components/ui'

const App: React.FC = () => {
  return (
    <AppProvider>
      <TopBar />
      <main>
        <AppRouter />
      </main>
      <ScrollReveal />
      <ToastHost />
    </AppProvider>
  )
}

export default App
